import { FirebaseActionTypes, FirebaseActions } from '@web_opxp/features';

export const trackBridgeOpen: (filterid: number) => FirebaseActionTypes.IAnalyticsEventAction = (filterid) =>
  FirebaseActions.analyticsEventAction({
    eventName: 'bridge_open',
    parameters: [{ key: 'filterid', value: filterid }],
  });

export const trackBridgeCta: (filterid: number) => FirebaseActionTypes.IAnalyticsEventAction = (filterid) =>
  FirebaseActions.analyticsEventAction({ eventName: 'bridge_cta', parameters: [{ key: 'filterid', value: filterid }] });

export const trackBridgeSkip: (filterid: number) => FirebaseActionTypes.IAnalyticsEventAction = (filterid) =>
  FirebaseActions.analyticsEventAction({
    eventName: 'bridge_skip',
    parameters: [{ key: 'filterid', value: filterid }],
  });

export const trackNoNamespaceBridgeSkip: (
  filterid: number,
  language: string
) => FirebaseActionTypes.IAnalyticsEventAction = (filterid, language) =>
  FirebaseActions.analyticsEventAction({
    eventName: 'bridge_skip',
    parameters: [
      { key: 'filterid', value: filterid },
      { key: 'user_language', value: language },
    ],
  });
